<!-- Single Button Component -->
<script lang="ts">
	import { createEventDispatcher } from "svelte";

	export let orientation, defaultstyle, buttonStyle, mapping
	export let button: string;

	const dispatch = createEventDispatcher();
	function pressButton(uod: string) {
		dispatch('message', {
			event: button,
			value: uod
		})
	}
</script>

<!-- Note that {mapping} and {button} values can likely be merged to clean up code -->
<div class="recess {orientation} {defaultstyle ? 'shadow' : 'glass'} recess-{buttonStyle}" id="button_{ mapping }">

	<button value={button} class="button shadow button-{buttonStyle}"
		on:mousedown|preventDefault={() => pressButton('down')}
		on:touchstart|preventDefault={() => pressButton('down')}
		on:mouseup|preventDefault={() => pressButton('up')}
		on:touchend|preventDefault={() => pressButton('up')}
	>
		<div class="label">{mapping}</div>
	</button>

</div>


<style>
	/* Default button styles*/
	.recess, .button, .label {
		transition: all 0.2s;
	}
	.button {
		box-shadow: none;
	}
	.button:active {
		background-color: #fff !important;
	}
	.label {
		font-size: 1.3rem;
		font-weight: 700;
		margin-top: 0%;
		color: rgba(0,0,0,0.3);
	}

	/* Default theme */
	.recess-default {
		box-shadow: inset 0 10px 15px rgb(0 0 0 / 30%);
	}
	.button-default {
		background-color: rgba(0,0,0,0.1);
		border: 1.5px solid rgba(255,255,255,1);
	}
	.button-default div.label {
		color: rgba(255,255,255,1);
	}

	/* Xbox Theme: {buttonStlye} value toggles between "default", "mtn" and "colour" */
	.recess-colour {
		background-color: rgba(0, 0, 0, 0.25);
		/* background: linear-gradient(0deg, rgba(255,255,255,0.1) 30%, rgba(0,0,0,0.2) 70%); */
		background: rgba(0,0,0,0);
		box-shadow: none !important;
	}
	#button_A .button-colour {
		background-color: #3cdb4e;		/* Xbox Green */
		background: linear-gradient(0deg, rgba(42,163,56,1) 0%, rgba(60,219,78,1) 40%, rgba(60,219,78,1) 60%, rgba(151,255,163,1) 100%);
	}
	#button_B .button-colour {
		background-color: #d04242;		/* Xbox Red */
		background: linear-gradient(0deg, rgba(161,38,38,1) 0%, rgba(208,66,66,1) 40%, rgba(208,66,66,1) 60%, rgba(245,112,112,1) 100%);
	}
	#button_X .button-colour {
		background-color: #40ccd0;		/* Xbox Blue */
		background: linear-gradient(0deg, rgba(34,148,152,1) 0%, rgba(64,204,208,1) 40%, rgba(64,204,208,1) 60%, rgba(136,250,254,1) 100%);
	}
	#button_Y .button-colour {
		background-color: #ecdb33;		/* Xbox Yellow */
		background: linear-gradient(0deg, rgba(195,180,27,1) 0%, rgba(236,219,51,1) 40%, rgba(236,219,51,1) 60%, rgba(255,244,135,1) 100%);
	}
	.button-colour {
		box-shadow: inset 0 -4px 0px rgb(0 0 0 / 30%);
	}
	.button-colour div.label {
		color: rgba(0,0,0,0.3);
		margin-top: -25%;
	}
	.button-colour:active {
		box-shadow: inset 0 -1px 0px rgb(0 0 0 / 30%) !important;
	}
	.button-colour:active div.label {
		margin-top: -8%;
	}

	/* MTN Theme: {buttonStlye} value toggles between "default" and "mtn" */
	.recess-mtn {
		background-color: rgba(0, 0, 0, 0.75);
		box-shadow: none !important;
	}
	.button-mtn {
		background-color: #ffc107;		/* MTN Yellow */
		box-shadow: none !important;
	}
	.button-mtn div.label {
		color: rgba(0,0,0,1);
	}

	/* Orientations */
	.T { top: 0;}
	.B { bottom: 0;}
	.L { left: 0;}
	.R { right: 0;}

	.TM { top: 10%; }
	.BM { bottom: 10%; }
	.LM { left: 10%; }
	.RM { right: 10%; }

</style>
